export default {"src":"/_next/static/media/DTLLogo.6d54df64.svg","height":45,"width":73};